import { Mapper } from "../../../../base/utils/mapper";
import { InabilityResponseModel } from "../../../../domain/models/consult/inability-response.model";
import { InabilityResponseEntity } from "../entities/inability-response.entity";

export class InabilityImplementationRepositoryMapper extends Mapper<InabilityResponseEntity, InabilityResponseModel> {
    mapFrom(param: InabilityResponseEntity): InabilityResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: InabilityResponseModel): InabilityResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}